import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { MainserviceService } from '../service/mainservice.service';
import { User } from '../model/User.model';
import { StudentMaster } from '../model/StudentMaster.model';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';
import { PaymentIntegration } from '../model/PaymentIntegration.model';
import { ReceiptMaster } from '../model/ReceiptMaster.model';
import { PredefinedMaster } from '../model/PredefinedMaster.model';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from 'sweetalert2'
import { CourseFeesMaster } from '../model/CourseFeesMaster.model';
import { CourseMaster } from '../model/CourseMaster.model';
import { Content } from '@angular/compiler/src/render3/r3_ast';
import { ContentMaster } from '../model/ContentMaster.model';
import { saveAs } from 'file-saver';
import { MessageService } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { CompanyDetailMaster } from '../model/CompanyDetailMaster.model';
import { Meta } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';


declare var require: any
const FileSaver = require('file-saver');
@Component({
  selector: 'app-my-course',
  templateUrl: './my-course.component.html',
  styleUrls: ['./my-course.component.scss']
})
export class MyCourseComponent implements OnInit {
  user: User = new User();
  studentMaster: StudentMaster = new StudentMaster();
  predefinedMaster: PredefinedMaster = new PredefinedMaster();

  showbtn1: boolean = true;
  showbtnongoing: boolean = true;
  showbtncompleted: boolean = true;
  showDialog: boolean=false;

  totalRecords1: number = 0;
  ongoingRecords: number = 0
  completedRecords: number = 0;

  ongoingEnrollCourseMasterList: EnrollCourseMaster[] = [];
  completedEnrollCourseMasterList: EnrollCourseMaster[] = [];
  enrollCourseMaster: EnrollCourseMaster = new EnrollCourseMaster();
  enrollCourseMasterCompleted: EnrollCourseMaster = new EnrollCourseMaster();

  paymentIntegration: PaymentIntegration = new PaymentIntegration();
  receiptMasterList: ReceiptMaster[] = [];
  enrollCourseMasterLectureSwitch: EnrollCourseMaster = new EnrollCourseMaster();
  switchLecture: boolean = false;
  openreceiptDialog: boolean = false;
  displaystudentprofile: boolean = false;
  cities: any[];
  pageSize: number = 6;
  pageNumber: number = 0;
  selectedCity: any;
  index: number = 0;
  enrollCourseMasterData: EnrollCourseMaster = new EnrollCourseMaster();
  predefineMaster: PredefinedMaster = new PredefinedMaster();
  receiptFeesMaster: ReceiptMaster[] = [];
  receiptMaster: ReceiptMaster = new ReceiptMaster();
  totalAmount: number = 0;
  predefineMasterList: PredefinedMaster[] = [];
  maxDate: Date;
  studentProfileImagePath: any;
  uploadStudentProfileFiles: any[] = [];
  fatherProfileImagePath: any;
  uploadFatherProfileFiles: any[] = [];
  motherProfileImagePath: any;
  uploadMotherProfileFiles: any[] = [];
  courselistTemp: CourseMaster = new CourseMaster();
  courseMasterList: CourseMaster[] = [];
  companyDetailMaster:CompanyDetailMaster = new CompanyDetailMaster();

  constructor(private meta: Meta, private titleService: Title,private authService: AuthService, private router: Router, private mainService: MainserviceService, private messageService: MessageService, public spinnerService: NgxSpinnerService) {
    this.meta.updateTag({ name: 'description', content: "Elevate your real estate expertise with our tailored programs. Start your journey to mastery today" });
    titleService.setTitle("Edstate Course Catalog: Your Gateway to Real Estate Mastery");
   }

  ngOnInit() {
    this.spinnerService.show()
    this.getEnrollCourse('ONGOING', this.enrollCourseMaster);
    this.getEnrollCourse('COMPLETED', this.enrollCourseMasterCompleted);
    this.getCompanyDetail();
    this.getCourseMasterList();

  }

  getEnrollCourse(code: string, enrollCourse: EnrollCourseMaster) {


    let courseStatus = new PredefinedMaster();
    courseStatus.code = code

    enrollCourse.courseStatus = courseStatus;

    let studentTemp = new StudentMaster();
    studentTemp.studentMasterId = this.authService.getUserSession().studentMasterId;

    enrollCourse.studentMaster = studentTemp;

    enrollCourse.pageNumber = enrollCourse.pageNumber
      ? enrollCourse.pageNumber
      : this.pageNumber;
    enrollCourse.pageSize = enrollCourse.pageSize
      ? enrollCourse.pageSize
      : this.pageSize;


    this.mainService.getMyEnrolledCourseList(enrollCourse).subscribe(data => {
      if (code == 'ONGOING') {
        this.ongoingEnrollCourseMasterList = data;
        this.getEnrollListLength('ONGOING', this.enrollCourseMaster)
      } else if (code == 'COMPLETED') {
        this.completedEnrollCourseMasterList = data;
        this.getEnrollListLength('COMPLETED', this.enrollCourseMasterCompleted)
      }
    })

  }


  incrementPageOngoing() {

    this.enrollCourseMaster.pageNumber = this.enrollCourseMaster.pageNumber
    this.enrollCourseMaster.pageSize = this.enrollCourseMaster.pageSize + 6

    this.getEnrollCourse('ONGOING', this.enrollCourseMaster);


    if (this.enrollCourseMaster.pageSize >= this.ongoingRecords) {

      this.showbtnongoing = false;
    }
  }

  incrementPageCompleted() {

    this.enrollCourseMasterCompleted.pageNumber = this.enrollCourseMasterCompleted.pageNumber
    this.enrollCourseMasterCompleted.pageSize = this.enrollCourseMasterCompleted.pageSize + 6


    this.getEnrollCourse('COMPLETED', this.enrollCourseMasterCompleted);


    if (this.enrollCourseMasterCompleted.pageSize >= this.completedRecords) {

      this.showbtncompleted = false;
    }
  }


  incrementPage1() {

    this.courselistTemp.pageNumber = this.courselistTemp.pageNumber
    this.courselistTemp.pageSize = this.courselistTemp.pageSize + 5


    this.getCourseMasterList();


    if (this.courselistTemp.pageSize >= this.totalRecords1) {

      this.showbtn1 = false;
    }
  }
  resumeChapter(enrollcourse: EnrollCourseMaster) {

    if (enrollcourse.lastStudentLectureMaster != null && enrollcourse.lastStudentLectureMaster != undefined) {
      this.authService.setlectureMasterSession(enrollcourse.lastStudentLectureMaster)
      this.router.navigateByUrl('/chapter-details')
    }


  }

  downloadFile(fileUrl: string) {

    if (fileUrl === null) {
      this.messageService.add({ severity: 'error', summary: 'No Certificate', detail: 'available' });
      return;
    }

    var fileUrlSplit = fileUrl.split("/");

    FileSaver.saveAs(fileUrl, fileUrlSplit[fileUrlSplit.length - 1]);

  }


  downloadCertificate(enrollCourseMaster: EnrollCourseMaster) {

    if (enrollCourseMaster.examResultFilePath != null) {
      this.downloadFile(enrollCourseMaster.examResultFilePath);
    } else {
      this.messageService.add({ severity: 'error', summary: 'No Certificate', detail: 'available' });
    }
  }


  getCourseMasterList() {

    this.courselistTemp.isMasterCourse = false;
    this.courselistTemp.pageNumber = this.courselistTemp.pageNumber
      ? this.courselistTemp.pageNumber
      : this.pageNumber;
    this.courselistTemp.pageSize = this.courselistTemp.pageSize
      ? this.courselistTemp.pageSize
      : this.pageSize;

    this.mainService.getCourseMasterList(this.courselistTemp).subscribe(
      (data) => {
        this.courseMasterList = data;
        this.spinnerService.hide()
        this.getCourseMasterListLength();

      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
            //   this.spinnerService.hide();
            return JSON.parse(jsonString);
          } else {
            this.authService.showMessage('error', 'Something went wrong', '');
            //  this.spinnerService.hide();
          }
        }
      }
    );
  }

  viewEnrollCourseMaster(enrollCourseMaster: EnrollCourseMaster) {
    let enrollCourseMasterTemp = new EnrollCourseMaster();
    enrollCourseMasterTemp.enrollCourseMasterId = enrollCourseMaster.enrollCourseMasterId;
    this.authService.setEnrollCourseMasterSession(enrollCourseMasterTemp);
    this.router.navigateByUrl('/mycourse-details');
  }


  viewCourse(courseMaster: CourseMaster) {
    this.authService.setcourseMasterSession(courseMaster);


    this.router.navigateByUrl('/course-details');

  }


  getCourseMasterListLength() {

    this.courselistTemp.isMasterCourse = false;
    this.mainService.getCourseMasterListLength(this.courselistTemp).subscribe(data => {
      this.totalRecords1 = data;

    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        this.courselistTemp = JSON.parse(jsonString);

      }


    })
  }

  startExamDialog() {
    this.showDialog = true;

  }

  startExam() {
    this.router.navigateByUrl('/exam');
  }

  getCompanyDetail(): any {
    // this.spinnerService.show();
  
    this.mainService.getCompanyDetail(new CompanyDetailMaster()).subscribe(
      data => {
        this.companyDetailMaster = data;
        // this.spinnerService.hide();
      },
      error => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 200) {
            let jsonString = error.error.text;
            jsonString = jsonString.substr(
              0,
              jsonString.indexOf('{"timestamp"')
            );
         //   this.spinnerService.hide();
            let data = JSON.parse(jsonString);
            this.companyDetailMaster = data;
          } else {
            this.authService.showMessage('error','Something went wrong', '');
          //  this.spinnerService.hide();
          }
          // this.spinnerService.hide();
        }
      }
    );
  }



  getEnrollListLength(code: string, enrollCourse: EnrollCourseMaster) {

    this.mainService.getEnrollCourseMasterListLength(enrollCourse).subscribe(data => {

      if (code == 'ONGOING') {
        this.ongoingRecords = data;
      }
      if (code == 'COMPLETED') {
        this.completedRecords = data;
      }




    }, (err: HttpErrorResponse) => {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
        enrollCourse = JSON.parse(jsonString);

      }


    })
  }




}



